import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { SOURCE_TYPE } from 'src/app/core/layers/base-layer.class';

@Component({
  selector: 'mood-admin',
  templateUrl: './admin.component.html',
  styleUrls: [
    'admin.component.scss'
  ]
})
export class AdminComponent implements OnInit {
  constructor(
    private _authService: AuthService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
  )
  { }

  ngOnInit(): void {
    const oldType = this._activatedRoute.snapshot.queryParamMap.get('type');
    const oldId = this._activatedRoute.snapshot.queryParamMap.get('id');

    if (oldType === SOURCE_TYPE.COVARIATE) {
      this._router.navigate(
        ['covariate/datasets'],
        {
          relativeTo: this._activatedRoute,
          queryParams: {
            id: oldId
          }
        }
      );
    }
  }

  public get isAdmin() {
    return this._authService.userHasAccessToDatasetAdmin;
  }
}
